import * as Sentry from "@sentry/react";

import version from "../version";

export const initSentry = () => {
  const currentEnvironment =
    import.meta.env.VITE_APP_ENVIRONMENT || "development";

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: version,
    dist: `${currentEnvironment}-${version}`,
    environment: currentEnvironment,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
  });
};
